/**
 * Development-only runtime logging for the hybrid preview workflow.
 * Enable with ?a11y_debug=1 or localStorage.a11y_debug = "1".
 * Pair with: npm run preview:debug (Playwright sidecar → .cursor/debug-{session}.log).
 */
(function () {
  var CONSOLE_PREFIX = '__A11Y_DEBUG_NDJSON__';

  function a11yDebugEnabled() {
    try {
      if (typeof URLSearchParams !== 'undefined') {
        var params = new URLSearchParams(window.location.search);
        if (params.get('a11y_debug') === '1') {
          return true;
        }
      }
      return window.localStorage && window.localStorage.getItem('a11y_debug') === '1';
    } catch (e) {
      return false;
    }
  }

  function a11yDebugSessionId() {
    if (window.__A11Y_DEBUG_SESSION_ID) {
      return String(window.__A11Y_DEBUG_SESSION_ID);
    }
    try {
      return window.localStorage.getItem('a11y_debug_session') || 'preview';
    } catch (e) {
      return 'preview';
    }
  }

  /**
   * @param {{ location: string, message: string, data?: object, hypothesisId?: string, runId?: string }} opts
   */
  function a11yDebugLog(opts) {
    if (!a11yDebugEnabled() || !opts || !opts.location || !opts.message) {
      return;
    }
    var entry = {
      sessionId: a11yDebugSessionId(),
      location: opts.location,
      message: opts.message,
      data: opts.data || {},
      timestamp: Date.now(),
      hypothesisId: opts.hypothesisId || '',
      runId: opts.runId || '',
    };
    window.__a11yDebug = window.__a11yDebug || [];
    window.__a11yDebug.push(entry);
    console.log(CONSOLE_PREFIX + JSON.stringify(entry));
    if (typeof window.__previewDebugIngest === 'function') {
      try {
        var p = window.__previewDebugIngest(entry);
        if (p && typeof p.catch === 'function') {
          p.catch(function () {});
        }
      } catch (e) {
        /* sidecar not running */
      }
    }
  }

  window.a11yDebugEnabled = a11yDebugEnabled;
  window.a11yDebugLog = a11yDebugLog;
})();
